import { ImageType } from "@nova/constants"
import { InfraredImage } from "@nova/protobuf"
import {
    booleanValidator,
    entityValidator,
    enumValidator,
    idValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
} from "../util"

export const createInfraredImageValidator = entityValidator(InfraredImage, {
    id: { validators: idValidators, nonNull: true },
    longitude: { validators: longitudeValidators, nonNull: true },
    latitude: { validators: latitudeValidators, nonNull: true },
    altitude: { validators: [], nonNull: true },
    height: { validators: [] },
    pitch: { validators: [] },
    yaw: { validators: [] },
    roll: { validators: [] },
    takenAt: { validators: [], nonNull: true },
    fov: { validators: [], nonNull: true },
    make: { validators: [] },
    focalLength: { validators: [] },
    size: { validators: [], nonNull: true },
    imageWidth: { validators: [] },
    imageHeight: { validators: [] },
    imageType: { validators: enumValidator("imageType", ImageType) },
    hasLRF: { validators: booleanValidator("hasLRF") },
})

export const updateInfraredImageValidator = entityValidator(InfraredImage, {})

export const getDefaultInfraredImageCreateArgs = () => ({})

export type CreateInfraredImageArgs = UnionToTuple<keyof typeof createInfraredImageValidator>
export type UpdateInfraredImageArgs = UnionToTuple<keyof typeof updateInfraredImageValidator>
